// ÐÑÐµÐ½Ð´ ÑÐ±Ð¾ÑÐºÐ¸: DOSCAR (Ð¿Ð¾ ÑÐ¼Ð¾Ð»ÑÐ°Ð½Ð¸Ñ) Ð¸Ð»Ð¸ Horizon (Rox, JetQ).
//
// ÐÐ´Ð¸Ð½ ÐºÐ¾Ð´ Ð¾Ð±ÑÐ»ÑÐ¶Ð¸Ð²Ð°ÐµÑ ÑÑÐ¸ Ð±ÑÐ¾ÐºÐµÑÐ°. Ð Ð°Ð½ÑÑÐµ Ð¿Ð°Ð»Ð¸ÑÑÑ Ð¸ Ð»Ð¾Ð³Ð¾ÑÐ¸Ð¿ Ð´ÐµÑÐ¶Ð°Ð»Ð¸ Ð²
// Ð¾ÑÐ´ÐµÐ»ÑÐ½ÑÑ Ð²ÐµÑÐºÐ°Ñ Ð¸ Ð¿ÑÐ°Ð²Ð¸Ð»Ð¸ ÑÐ²ÐµÑÐ° ÑÑÐºÐ°Ð¼Ð¸ Ð² Ð¿Ð¾Ð»ÑÑÐ¾ÑÐ½Ðµ ÑÐ°Ð¹Ð»Ð¾Ð² â Ð²ÐµÑÐºÐ¸
// ÑÐ°Ð·ÑÐµÐ·Ð¶Ð°Ð»Ð¸ÑÑ, Ð¸ JetQ Ð·Ð°ÑÑÑÑÐ» Ð½Ð° ÐºÐ¾Ð´Ðµ Ð¾Ñ Ð¸ÑÐ»Ñ. Ð¢ÐµÐ¿ÐµÑÑ Ð±ÑÐµÐ½Ð´ Ð²ÑÐ±Ð¸ÑÐ°ÐµÑÑÑ
// Ð¿ÑÐ¸ ÑÐ±Ð¾ÑÐºÐµ Ð¿ÐµÑÐµÐ¼ÐµÐ½Ð½Ð¾Ð¹ REACT_APP_BRAND (Ð² .env ÑÐµÑÐ²ÐµÑÐ°), Ð° ÑÐ²ÐµÑÐ° Ð¶Ð¸Ð²ÑÑ Ð²
// CSS-Ð¿ÐµÑÐµÐ¼ÐµÐ½Ð½ÑÑ (theme.css) Ð¸ Ð² Ð¿Ð°Ð»Ð¸ÑÑÐµ Ð½Ð¸Ð¶Ðµ.
//
//   REACT_APP_BRAND=          â doscar (ÐºÐ°Ðº Ð±ÑÐ»Ð¾)
//   REACT_APP_BRAND=horizon   â ÑÐ¸Ð½ÑÑ Ð¿Ð°Ð»Ð¸ÑÑÐ° Ð¸ Ð»Ð¾Ð³Ð¾ÑÐ¸Ð¿ Horizon

export const BRANDS = {
  doscar: {
    title: 'Doscar',
    // Ð¢ÑÐ¼Ð½ÑÐ¹ ÑÐ¾Ð½ ÑÐ°Ð¹Ð´Ð±Ð°ÑÐ° Ð¸ Ð·Ð°Ð³Ð¾Ð»Ð¾Ð²ÐºÐ¾Ð².
    dark: '#494136',
    // ÐÑÐ½Ð¾Ð²Ð½Ð¾Ð¹ Ð°ÐºÑÐµÐ½Ñ: ÐºÐ½Ð¾Ð¿ÐºÐ¸, Ð¸ÐºÐ¾Ð½ÐºÐ¸, ÑÐ°Ð¼ÐºÐ¸.
    primary: '#D9BC92',
    // ÐÐ¾Ð´ÑÐ²ÐµÑÐºÐ° ÑÑÑÐ¾Ðº ÑÐ°Ð±Ð»Ð¸Ñ.
    row: '#F8F0E4',
  },
  horizon: {
    title: 'Horizon',
    dark: '#404A5F',
    primary: '#B45436',
    row: '#F4F4F4',
  },
};

export const resolveBrand = (value) => {
  const key = String(value || '').trim().toLowerCase();
  return BRANDS[key] ? key : 'doscar';
};

export const BRAND = resolveBrand(process.env.REACT_APP_BRAND);
export const brand = BRANDS[BRAND];

/** ÐÑÐ¸Ð¼ÐµÐ½Ð¸ÑÑ Ð±ÑÐµÐ½Ð´ Ðº Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÑ: Ð°ÑÑÐ¸Ð±ÑÑ Ð´Ð»Ñ CSS-Ð¿ÐµÑÐµÐ¼ÐµÐ½Ð½ÑÑ Ð¸ Ð·Ð°Ð³Ð¾Ð»Ð¾Ð²Ð¾Ðº Ð²ÐºÐ»Ð°Ð´ÐºÐ¸. */
export const applyBrand = (doc = document) => {
  doc.documentElement.dataset.brand = BRAND;
  doc.title = brand.title;
};
